import * as firebase from 'firebase';
import helper from './helper';

export default class data {
    constructor() {
        firebase.initializeApp({
            apiKey: "AIzaSyDDV_GDjW9ppKVSJ3PbDsdR7_IZHKUEmSY",
            authDomain: "moneylist-f3ee5.firebaseapp.com",
            databaseURL: "https://moneylist-f3ee5.firebaseio.com/",
            projectId: "moneylist-f3ee5",
            storageBucket: "moneylist-f3ee5.appspot.com",
            messagingSenderId: "392241457211"
        });
    }

    load(userId, onSuccess) {
        if(!userId) return;
        firebase.database().ref(userId).on('value', (snapshot) => {
            onSuccess(snapshot.val());
        });
    }

    addTransaction(userId) {
        if(!userId) return;
        let pageSlug        = helper.getCurrentPageSlug();
        let defaultObject   = helper.getDefaultObject();
        firebase.database().ref(userId + '/' + pageSlug)
            .push(defaultObject);
    }

    editTransaction(userId, transactionId, key, value) {
        if(!userId) return;
        let pageSlug = helper.getCurrentPageSlug();
        firebase.database().ref(userId + '/' + pageSlug + '/' + transactionId + '/' + key).set(value);
    }

    deleteTransaction(userId, transactionId) {
        if(!userId) return;
        let pageSlug = helper.getCurrentPageSlug();
        firebase.database().ref(userId + '/' + pageSlug + '/' + transactionId).remove();
    }

    updateBalance(userId, value) {
        if(!userId) return;
        firebase.database().ref(userId + '/balance').set(value);
    }
}



// WEBPACK FOOTER //
// ./src/services/data.js